module.exports = function() {
  return new Worker(__webpack_public_path__ + "3d4aebfa4bed8504acde.worker.js");
};